/**
 * Home Page - Landing page with hero banner and featured products
 */

import { ContentBlock, Box } from 'braid-design-system';
import type React from 'react';
import { Link } from 'react-router';

import { HeroBanner } from '../../components/HeroBanner/HeroBanner';
import { PageHead } from '../../components/PageHead/PageHead';
import { ProductGrid } from '../../components/ProductGrid/ProductGrid';
import {
  buildOrganizationJsonLd,
  buildWebSiteJsonLd,
} from '../../constants/jsonLd';
import { SITE_DESCRIPTION, SITE_NAME } from '../../constants/site';
import { getFeaturedProducts, getCategories } from '../../data/productCatalog';

import * as styles from './Home.css';

export const Home: React.FC = () => {
  const categories = getCategories();
  const featuredProducts = getFeaturedProducts();

  return (
    <>
      <PageHead
        title={SITE_NAME}
        description={SITE_DESCRIPTION}
        path="/"
        jsonLd={[buildOrganizationJsonLd(), buildWebSiteJsonLd()]}
      />
      <HeroBanner />

      <ContentBlock width="large">
        <Box paddingY="large">
          <h2 className={styles.sectionTitle}>Featured Products</h2>
          <ProductGrid products={featuredProducts} />
        </Box>
      </ContentBlock>

      <ContentBlock width="large">
        <Box paddingY="large">
          <h2 className={styles.sectionTitle}>Shop by Category</h2>
          <div className={styles.categoriesGrid}>
            {categories.map((category) => (
              <Link
                key={category}
                to={`/products?category=${encodeURIComponent(category)}`}
                className={styles.categoryCard}
              >
                <div className={styles.categoryName}>{category}</div>
              </Link>
            ))}
          </div>
        </Box>
      </ContentBlock>
    </>
  );
};
